import { c as _c } from "react/compiler-runtime";
import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { GrowthbookFlagsEnum } from 'growthbook/types';
import { useMemo } from 'react';
import useUser from 'shared/hooks/use-user';
import { AutomationRuleActionsEnum } from '../enums/action-enum';
export const useAllowedActions = () => {
  const $ = _c(5);
  const {
    isRootAdmin,
    isWhiteLabelOwner
  } = useUser();
  const whiteLabelFeatureIsOn = useFeatureIsOn(GrowthbookFlagsEnum.WhiteLabel);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = Object.values(AutomationRuleActionsEnum);
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== isRootAdmin || $[2] !== isWhiteLabelOwner || $[3] !== whiteLabelFeatureIsOn) {
    t1 = t0.filter(action => {
      switch (action) {
        case AutomationRuleActionsEnum.create_user:
          {
            return isRootAdmin;
          }
        case AutomationRuleActionsEnum.create_white_label_user:
          {
            if (!whiteLabelFeatureIsOn) {
              return false;
            }
            return isWhiteLabelOwner;
          }
        default:
          {
            return true;
          }
      }
    });
    $[1] = isRootAdmin;
    $[2] = isWhiteLabelOwner;
    $[3] = whiteLabelFeatureIsOn;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const data = t1;
  return data;
};